import { Link, useNavigate } from 'react-router-dom'
import ExtraForm from '../../components/ExtraForm'
import Header from '../../components/Header'
import Page from '../../components/Page'
import { useCreateExtra } from '../../hooks/extra'

export default function ExtraCreate() {
  const createExtra = useCreateExtra()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/extras">Extra</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Aggiungi
            </li>
          </ol>
        </nav>
      </Header>
      <div className="py-3 overflow-y-auto flex-1">
        <ExtraForm
          save={async (extra) => {
            const savedExtra = await createExtra.mutateAsync(extra)
            navigate(`/extras/${savedExtra.id}`)
          }}
        />
      </div>
    </Page>
  )
}
